import React from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const floatingEmojis = ['🥘', '🫓', '🌿', '🥗', '🍛', '🧆', '🫙', '🌶️'];
export function Hero() {
  return <section className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 px-4 overflow-hidden bg-[#fffbf5]" data-id="element-60">
      {/* Decorative blobs */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-green-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 pointer-events-none" data-id="element-61" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-60 pointer-events-none" data-id="element-62" />
      <div className="absolute top-40 left-1/2 w-64 h-64 bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-40 pointer-events-none" data-id="element-63" />

      <div className="max-w-5xl mx-auto relative text-center" data-id="element-64">
        {/* Logo image */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-8" data-id="element-65">
          <img src="https://cdn.magicpatterns.com/uploads/2pSPbYAXJgMUjkWB2iejxz/bevegtoday.png" alt="BeVegToday" className="h-28 md:h-36 w-auto object-contain" data-id="element-66" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-green-100 text-green-800 font-semibold text-sm mb-6" data-id="element-67">
          <span className="relative flex h-2.5 w-2.5" data-id="element-68">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-69" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" data-id="element-70" />
          </span>
          Indian & Fusion Vegetarian Recipes
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-5xl lg:text-7xl font-extrabold text-stone-900 leading-[1.05] mb-6" style={{
        fontFamily: 'Poppins, sans-serif'
      }} data-id="element-71">
          Be Veg.{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-green-400" data-id="element-72">
            Today.
          </span>{' '}
          🌿
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="text-xl text-stone-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-73">
          Discover quick, healthy, and delicious vegetarian recipes — from
          classic Indian curries to exciting fusion creations. Fresh recipes
          every day.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35
      }} className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-74">
          <a href="#finder" className="inline-flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg shadow-green-600/30 hover:scale-105" data-id="element-75">
            Find a Recipe <ArrowRight size={20} data-id="element-76" />
          </a>
          <a href="https://www.youtube.com/c/BeVegToday" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-white hover:bg-stone-50 text-stone-800 border-2 border-stone-200 px-8 py-4 rounded-full font-bold text-lg transition-all hover:scale-105" data-id="element-77">
            <PlayCircle size={20} className="text-red-600" data-id="element-78" /> Watch Channel
          </a>
        </motion.div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap gap-8 justify-center" data-id="element-79">
          {[{
          label: 'Recipes',
          value: '48+'
        }, {
          label: 'Categories',
          value: '14'
        }, {
          label: 'Vegetarian',
          value: '100%'
        }].map(stat => <div key={stat.label} className="text-center" data-id="element-80">
              <p className="text-3xl font-extrabold text-green-600" style={{
            fontFamily: 'Poppins, sans-serif'
          }} data-id="element-81">
                {stat.value}
              </p>
              <p className="text-stone-500 text-sm font-medium" data-id="element-82">{stat.label}</p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}